import { Grid, Typography } from "@mui/material";
import React from "react";
import { Card, CardContent, Box } from "@mui/material";
import Icon from "@mui/icons-material/Brush"; // Assuming this is the icon you want to use
import styles from "./style.module.scss";
import piggy from "@assets/piggy.png";
import editor from "@assets/editor.png";
import harmony from "@assets/harmony.png";
import prompt from "@assets/prompt.png";
import Spring from "@components/Spring";

const cardStyles = {
  card: {
    backgroundColor: "#000000",
    color: "#ffffff",
    maxWidth: "650px",

    margin: "1rem",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    padding: "2px", // For the gradient border
    background: "linear-gradient(45deg, #F90A5C, #FB9618)",
  },
  cardInner: {
    minHeight:"220px",
    borderRadius: "10px",
    backgroundColor: "#000000",
    color: "#ffffff",
    padding: "16px",
    height: "100%",
    width: "100%",
  },

  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  content: {
    fontSize: "18px",
  },
};

const CustomCard = ({ title, description, img }) => {
  return (
    <Box style={cardStyles.card}>
      <Box style={cardStyles.cardInner}>
        <CardContent>
          <Box style={cardStyles.header}>
            <img src={img} style={{ width: "50px", marginRight: "1rem" }}></img>
            <Typography style={cardStyles.title}>{title}</Typography>
          </Box>
          <Typography style={cardStyles.content}>{description}</Typography>
        </CardContent>
      </Box>
    </Box>
  );
};

const WhyChoose = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          textAlign: "center",
          justifyContent: "center",
          marginTop: "8rem",
        }}
      >
        <Typography

          gutterBottom
          className={styles.feature_heading}
        >
          Why Choose UE COMIX?
        </Typography>
      </div>
   <Spring >
   <Grid container spacing={2} style={{flexDirection:"column"}} >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}

          className={styles.card_row}


        >
          <CustomCard
            img={piggy}
            title={"Create Comics Without Breaking The Bank"}
            description={
              "We offer a cost-effective solution for bringing your comic ideas to life, without sacrificing quality or creativity."
            }
          />
          <CustomCard
            img={harmony}
            title={"Visual Harmony At Its Best"}
            description={
              "Our platform ensures consistency in art style and quality throughout your comic, making your story flow seamlessly from start to finish."
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={styles.card_row}
        >
          <CustomCard
            img={prompt}
            title={"Hassle-Free Prompt Generation"}
            description={
              "UE COMIX simplifies the image generation process, allowing you to focus on storytelling without getting bogged down entering complicated prompts."
            }
          />
          <CustomCard
            img={editor}
            title={"Your Comic Creation Heaven"}
            description={
              "Our platform is designed specifically for comic creators, providing an intuitive and user-friendly interface to help you create the unthinkable."
            }
          />
        </Grid>
      </Grid>
   </Spring>
    </div>
  );
};

export default WhyChoose;
